var ContactUsMapModule = function () {

    var self = this;

    /**
     * @var array
     */
    self.container = jQuery('#contact-us-map-container');
    if (self.container.length === 0) {
        return;
    }

    /**
     * @var array
     */
    self.mapElement = self.container.children('div');
    if (self.mapElement.length === 0) {
        return;
    }
    
    /**
     * @var object
     */
    self.map = null;
    
    /**
     * @var object
     */
    self.place = null;

    /**
     * Load Google API
     */
    self.loadGoogleApi = function () {
        EventBus.publish('load-google-api', self.googleApiLoaded);
    };
    
    /**
     * All modules have been initialised
     */
    self.modulesInitialised = function () {
        EventBus.publish('load-google-places-library');
    };

    /**
     * Google API has been loaded
     */
    self.googleApiLoaded = function () {
        EventBus.publish('load-google-maps', self.googleMapsLoaded);
    };

    /**
     * Google Maps API has been loaded
     */
    self.googleMapsLoaded = function () {
        
        var geocoder = new google.maps.Geocoder;
        
        //Lookup place by ID
        geocoder.geocode(
            {placeId: self.container.data('google-place-id')},
            function (results, status) {
                
                if (status != google.maps.places.PlacesServiceStatus.OK || results.length === 0) {
                    return;
                }
                
                //Store first result as place
                self.place = results[0];

                //Construct map at place's coordinates
                EventBus.publish('construct-google-map', {
                    center: {
                        latitude: self.place.geometry.location.lat(),
                        longitude: self.place.geometry.location.lng()
                    },
                    callback: self.mapConstructed,
                    element: self.mapElement[0],
                    options: {
                        styles: [
                            {
                                featureType: 'poi',
                                elementType: 'business',
                                stylers: [
                                    {visibility: 'off'}
                                ]
                            }
                        ],
                        zoom: 16
                    }
                });
            
            }
        );
        
    };

    /**
     * Map element has been constructed
     * @param data
     */
    self.mapConstructed = function (data) {
        
        self.map = data.map;
        
        var
            infowindow = new google.maps.InfoWindow()
            service = new google.maps.places.PlacesService(self.map),
            addressTitle = self.container.data('address-title')
        ;

        //Construct map marker
        var marker = new google.maps.Marker({
            map: self.map,
            position: self.place.geometry.location,
            title: addressTitle
        });
        
        //Listen for click on map marker
        /*google.maps.event.addListener(marker, 'click', function() {
            
            infowindow.setContent(
                '<div><strong>' + addressTitle + '</strong><br />' +
                self.place.formatted_address + '</div>'
            );
            
            infowindow.open(self.map, this);
            
        });*/
        
    };

    /**
     * Bind events
     */
    self.bindEvents = function () {
        EventBus.subscribe('run-modules', self.loadGoogleApi);
        EventBus.subscribe('modules-initialised', self.modulesInitialised);
    };

    self.bindEvents();

};

EventBus.subscribe('init-modules', function () {
    new ContactUsMapModule();
})